export default "__VITE_ASSET__CBqUxEMQ__"